<div *ngIf="loading" class="loader"><span class="spinner">Loading&#8230;</span></div>
